import { Tabs } from 'antd'
import React, { useEffect } from 'react';
import styles from "../style/BosPendingPage.module.css";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import BosTransactionListOne from './BosTransactionListOne';
import BosTransactionListTwo from './BosTransactionListTwo';
import { getAllCheckFirmIds } from '../../Common/commondata/commonData';
import { landingPageAction } from '../state/actions';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { Loading } from '../../Common';

const { TabPane } = Tabs;
export default function BosPendingPage() {
  return (
    <div className={styles.container}>
        <Switch>
            <Route
                exact
                path="/titleDoc"
                component={TabCommon}
            />
            <Route
                exact
                path="/complience"
                component={TabCommon}
            />
            <Route
                path="/"
                component={TabCommon}
            />
        </Switch>
    </div>
  )
}

function TabCommon(){
    const { pathname } = useLocation();
    const history = useHistory();
    let pathnme = pathname?.split("/");
    let idx = (pathnme?.[2] === "titleDoc") ? "3" : (pathnme?.[2] === "complience") ? "2" : "1";
    const handleChange = (key) => {
        if (key === "1") {
          history.push("/pendings");
        } else if (key === "2") {
          history.push("/pendings/complience");
        } else if (key === "3") {
          history.push("/pendings/titleDoc");
        }
    };

    return <Tabs
        size={"small"}
        activeKey={idx}
        onChange={handleChange}
        
    //   onTabClick={handleTabClick}
    //   tabBarStyle={!isMobile ? {margin: 5} : {}}
    >
        <TabPane tab={<div className={styles.tabHeading}>Pay Brokers</div>} key="1">
            {
                (idx === "1") && <PayBrokers/>
            }
        </TabPane>
        <TabPane tab={<div className={styles.tabHeading}>Document Complience</div>} key="2">
            {
                (idx === "2") && <DocTitle/>
            }
        </TabPane>
        <TabPane tab={<div className={styles.tabHeading}>Title Docs Needed</div>} key="3">
            {
                (idx === "3") && <DocTitle/>
            }
        </TabPane>
    </Tabs>
}

function PayBrokers(){
    const dispatch = useDispatch();
    const { allBackOfficeData } = useSelector((state) => state.account);
    const { pendingsData, pendingsLoading, pendingsError } = useSelector((state) => state.landingPageReducer.bosLandingReducer);
    let sourceAxios = axios.CancelToken.source();
    let unmounted = {
        value: false
    };
    useEffect(()=>{
        let firmIds = getAllCheckFirmIds(allBackOfficeData);
        dispatch(landingPageAction.getBosPendingsData({queryData: {...(firmIds?.length && {firmIds: firmIds?.join(",")}), section: "PENDINGS"}, allBackOfficeData, unmounted, sourceAxios}));

        return () => {
            unmounted.value = true;
            sourceAxios.cancel("Cancelling in cleanup");
        };
    }, [allBackOfficeData])

    return pendingsLoading ? <Loading /> : pendingsError ? "something went wrong" : <BosTransactionListOne arrayList={pendingsData}/>
}

function DocTitle(){
    const dispatch = useDispatch();
    const { allBackOfficeData } = useSelector((state) => state.account);
    const { pendingsData, pendingsLoading, pendingsError } = useSelector((state) => state.landingPageReducer.bosLandingReducer);
    let sourceAxios = axios.CancelToken.source();
    let unmounted = {
        value: false
    };
    useEffect(()=>{
        let firmIds = getAllCheckFirmIds(allBackOfficeData);
        dispatch(landingPageAction.getBosPendingsData({queryData: {...(firmIds?.length && {firmIds: firmIds?.join(",")}), section: "PENDINGS"}, allBackOfficeData, unmounted, sourceAxios}));

        return () => {
            unmounted.value = true;
            sourceAxios.cancel("Cancelling in cleanup");
        };
    }, [allBackOfficeData])

    return pendingsLoading ? <Loading /> : pendingsError ? "something went wrong" : <BosTransactionListTwo arrayList={pendingsData}/>
}
